"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pietro-di-feletto": {
    "3ba1d2d1": [{
      "hkey": "adfe9346",
      "slug": "rua-di-feletto",
      "name": "Rua di Feletto",
      "primary": true,
      "skipSearch": false
    }],
    "rua": [{
      "hkey": "adfe9346",
      "slug": "rua-di-feletto",
      "name": "Rua di Feletto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d78ac2db": [{
      "hkey": "638a75a2",
      "slug": "santa-maria-di-feletto",
      "name": "Santa Maria di Feletto",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "638a75a2",
      "slug": "santa-maria-di-feletto",
      "name": "Santa Maria di Feletto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;